import React, { Component } from 'react';
import firebase from 'firebase/app';
import { firebaseApp } from './firebase/';
import queryString from 'query-string';

import Button from 'react-bootstrap/Button';
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from 'react-toastify'

import {
  SignInButtons,
  saveSignInParam,
  onAuthStateChanged
} from './task/SignInButtons'
import UserNavbar from './task/UserNavbar'
import Footer from './task/Footer'

import './SettingsApp.css';


const db = firebaseApp.firestore();

class SettingsApp extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/settings/')),
      user: null,
      loading: true,
      error: null,
      userData: null,
    };
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  componentDidMount() {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.setState({
          error,
        });
        return;
      }
      this.loadUser(user)
        .then(result => {
          if (result && result.url) {
            window.history.pushState({}, null, result.url);
          }
          const query = queryString.parse(window.location.search);
          this.setState({
            loading: false,
            user,
            userData: result ? result.userData : null,
            error: query['auth-result'] || null
          })
        }).catch((error) => {
          console.error(error)
          this.setState({
            loading: false,
            error: error.message || error,
          })
        })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  async prepareGarminSignIn() {
    const userDocRef = db.collection('user').doc(this.state.user.uid)
    const userDataRef = await userDocRef.get()
    const userData = userDataRef.exists ? Object.assign({}, userDataRef.data()) : {}
    await userDocRef.set(Object.assign(userData, {
      garminUpdated: Date.now()
    }))
    return `/garmin/auth?user=${this.state.user.uid}`
  }

  garminSignIn() {
    this.prepareGarminSignIn()
      .then((url) => {
        window.location.href = url
      }).catch((error) => {
        console.error(error)
        this.setState({
          loading: false,
          error: error.message || error,
        })
      })
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  signOut(callback) {
    this.auth().signOut()
      .then(() => {
        this.setState({
          user: null,
        }, callback);
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  async loadUser(user) {
    if (!user) {
      return null
    }
    const userDocRef = db.collection('user').doc(user.uid)
    const userRef = await userDocRef.get()
    const query = queryString.parse(window.location.search);
    if (!query['garmin-user']) {
      const userData = await saveSignInParam(db.collection('user'), userRef)
      return { userData }
    }
    const userData = await saveSignInParam(null, userRef)
    const newData = Object.assign(
      Object.assign({}, userData),
      {
        garminUser: query['garmin-user'],
      }
    )
    await userDocRef.set(newData)
    return { userData: newData, url: '/settings/garmin' }
  }

  renderNeedsLogin() {
    return <div className='Login'>
      <SignInButtons
        description='Cloze Testアプリを設定するには、'
        signIn={(provider) => this.signIn(provider)}
      />
    </div>
  }

  renderGarmin() {
    return <div>
      <h2>Garmin設定</h2>
      {!(this.state.userData || {}).garminUser && <div>
        <p>
          Garmin活動量計のデータをCloze Testアプリに連携させるため、Garmin Connectでログインしてください。
        </p>
        <Button
          data-test-cloze-garmin-sign-in
          onClick={e => this.garminSignIn()}
          variant='success'>
          Garmin Connectでログイン
        </Button>
      </div>}
      {(this.state.userData || {}).garminUser && <div>
        <p>
          Garmin活動量計はすでに設定されています。
        </p>
        <Button
          data-test-cloze-garmin-sign-in
          onClick={e => this.garminSignIn()}
          variant='success'>
          Garmin Connectで再ログイン
        </Button>
      </div>}
    </div>
  }

  renderNoCategory() {
    return <div>
      <h2>Cloze Testアプリ設定</h2>
      設定項目が見つかりません: "{this.props.match.params.category}"
    </div>
  }

  render() {
    return <div>
      <UserNavbar
        user={this.state.user}
        onSignOut={() => this.signOut()}/>
      <div className='SettingsApp'>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
        {this.state.loading ? <div className='Loading'>
          <ClipLoader />
          <div>Loading...</div>
        </div> : (this.state.user ? <div className='SettingsPanel'>
          {this.props.match.params.category === 'garmin' ? this.renderGarmin() : this.renderNoCategory()}
        </div> : this.renderNeedsLogin())}
      </div>
      <Footer />
    </div>
  }
}

export default SettingsApp;
